<template>
    <div class="md:flex">
        <div class="md:w-1/2 md:pr-2 mb-2 md:mb-0">
            <label class="w-full block text-gray-700">Scheduled Date</label>
            <maz-picker
                v-if="send_date || current_date"
                id="date-picker"
                class="w-full relative"
                :model-value="send_date"
                @update:model-value="handleSendDateChange"
                :required="true"
                format="YYYY-MM-DD"
                display-format="MMM D, YYYY"
                :min-date="current_date"
            />
        </div>
        <div class="md:w-1/2 md:pl-2">
            <label class="w-full block text-gray-700">Send Time</label>
            <div class="flex -mx-2">
                <multiselect
                    class="w-1/3 mx-2"
                    v-model="send_hour"
                    :options="['12', '1', '2', '3', '4', '5', '6', '7', '8', '9', '10', '11']"
                    select-label=""
                    deselect-label=""
                />
                <multiselect
                    class="w-1/3 mx-2"
                    v-model="send_min":options="['00', '05', '10', '15', '20', '25', '30', '35', '40', '45', '50', '55']"
                    select-label=""
                    deselect-label=""
                />
                <multiselect
                    class="w-1/3 mx-2"
                    v-model="send_period"
                    :options="['AM', 'PM']"
                    select-label=""
                    deselect-label=""
                />
            </div>
        </div>
    </div>
</template>

<script>
export default {
    props: {
        modelValue: String,
    },
    emits: ['update:modelValue'],
    data() {
        return {
            current_date: null,
            send_date: null,
            send_hour: '12',
            send_min: '00',
            send_period: 'AM',
        }
    },
    computed: {
        value() {
            return this.modelValue;
        },
        sendTime: {
            get() {
                let hour = this.send_hour === "12" ? "00" : this.send_hour;

                if (this.send_period === "PM") {
                    hour = parseInt(hour, 10) + 12;
                }

                let send_date = this.send_date;
                if (send_date === null) {
                    send_date = '2023-09-15';
                }

                return `${send_date} ${hour}:${this.send_min}`;
            }
        }
    },
    watch: {
        sendTime() {
            this.$emit('update:modelValue', this.sendTime);
        },
        value() {
            this.parseValue();
        }
    },
    methods: {
        handleSendDateChange(date) {
            this.send_date = date;
        },
        parseValue() {
            if (!this.value) return;
            
            let date = this.value.split(' ')[0];
            let time = this.value.split(' ')[1];
            this.send_date = date;
         
            let [hour, min] = time.split(':');
            hour = parseInt(hour, 10);

            let period = 'AM';
            if (hour >= 12) {
                period = 'PM';
                if (hour > 12) {
                    hour -= 12;
                }
            }
            this.send_hour = '' + hour;
            this.send_min = min;
            this.send_period = period;
        }
    },
    mounted() {
        this.parseValue();
        
        this.current_date = new Date().toISOString().split('T')[0];
    }
}
</script>